export const statusColor = {
    'En cours': 'var(--status-en-cours)',
    'Terminé': 'var(--status-termine)',
    'En construction': 'var(--status-en-construction)',
    'En révision' : 'var(--status-revision)',
  };
  
  export const StatusDot = ({ status }) => {
    const color = statusColor[status];
    if (!color) return null;
    return (
      <span
        title={status}
        style={{
          display: 'inline-block',
          width: '10px',
          height: '10px',
          minWidth: '10px',
          backgroundColor: color,
          borderRadius: '2px',
          marginRight: '8px',
          verticalAlign: 'middle',
        }}
      />
    );
  };